import PropTypes from 'prop-types';
import React from 'react';

const NextjsInactive = ({ className }) => (
  <svg
    className={className}
    width="1731"
    height="857"
    viewBox="0 0 1731 857"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="242" cy="685" r="72" fill="url(#paint0_linear_1112_11783)" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="211.333" y="646.9">
        MEMORY
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="44"
      fontWeight="300"
      letterSpacing="0em"
    >
      <tspan x="199.197" y="692.4">
        92%
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="13"
      letterSpacing="0em"
    >
      <tspan x="213.704" y="715.55">
        Address:&#10;
      </tspan>
      <tspan x="210.117" y="731.55">
        0x4553e0
      </tspan>
    </text>
    <g filter="url(#filter0_ddd_1112_11783)">
      <rect x="412" y="330" width="728" height="430" rx="12" fill="white" />
    </g>
    <rect opacity="0.1" x="412" y="550" width="728" height="24" fill="#FD0054" />
    <path
      d="M1037.17 694.17H1056.49V695.711H1038.94V707.306H1055.45V708.847H1038.94V721.577H1056.69V723.118H1037.17V694.17ZM1058.22 694.17H1060.28L1069.37 706.901L1078.67 694.17L1091.32 678L1070.54 708.239L1081.25 723.118H1079.11L1069.37 709.577L1059.59 723.118H1057.5L1068.29 708.239L1058.22 694.17ZM1082.01 695.711V694.17H1104.03V695.711H1093.89V723.118H1092.11V695.711H1082.01ZM1013 694.17H1015.21L1045.74 740L1033.13 723.118L1014.85 696.36L1014.77 723.118H1013V694.17ZM1103.85 721.112C1103.49 721.112 1103.22 720.831 1103.22 720.467C1103.22 720.104 1103.49 719.823 1103.85 719.823C1104.22 719.823 1104.48 720.104 1104.48 720.467C1104.48 720.831 1104.22 721.112 1103.85 721.112ZM1105.59 719.416H1106.54C1106.55 719.931 1106.93 720.277 1107.48 720.277C1108.09 720.277 1108.44 719.905 1108.44 719.208V714.794H1109.41V719.213C1109.41 720.467 1108.68 721.19 1107.49 721.19C1106.36 721.19 1105.59 720.489 1105.59 719.416V719.416ZM1110.67 719.36H1111.63C1111.71 719.953 1112.29 720.329 1113.12 720.329C1113.89 720.329 1114.46 719.926 1114.46 719.373C1114.46 718.897 1114.1 718.611 1113.28 718.416L1112.48 718.222C1111.35 717.958 1110.84 717.412 1110.84 716.495C1110.84 715.383 1111.74 714.643 1113.1 714.643C1114.36 714.643 1115.28 715.383 1115.34 716.434H1114.4C1114.31 715.859 1113.81 715.5 1113.09 715.5C1112.32 715.5 1111.82 715.868 1111.82 716.43C1111.82 716.876 1112.14 717.131 1112.95 717.321L1113.64 717.49C1114.91 717.789 1115.44 718.308 1115.44 719.247C1115.44 720.442 1114.52 721.19 1113.04 721.19C1111.67 721.19 1110.74 720.476 1110.67 719.36V719.36Z"
      fill="black"
    />
    <rect opacity="0.1" x="461" y="367" width="1" height="393" fill="#181A1B" />
    <text
      opacity="0.6"
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="428.184" y="398.938">
        21&#10;
      </tspan>
      <tspan x="428.184" y="419.938">
        22&#10;
      </tspan>
      <tspan x="428.184" y="440.938">
        23&#10;
      </tspan>
      <tspan x="428.184" y="461.938">
        24&#10;
      </tspan>
      <tspan x="428.184" y="482.938">
        25&#10;
      </tspan>
      <tspan x="428.184" y="503.938">
        26&#10;
      </tspan>
      <tspan x="428.184" y="524.938">
        27&#10;
      </tspan>
      <tspan x="428.184" y="545.938">
        28&#10;
      </tspan>
      <tspan x="428.184" y="566.938">
        29&#10;
      </tspan>
      <tspan x="428.184" y="587.938">
        30&#10;
      </tspan>
      <tspan x="428.184" y="608.938">
        31&#10;
      </tspan>
      <tspan x="428.184" y="629.938">
        32&#10;
      </tspan>
      <tspan x="428.184" y="650.938">
        33&#10;
      </tspan>
      <tspan x="428.184" y="671.938">
        34&#10;
      </tspan>
      <tspan x="428.184" y="692.938">
        35&#10;
      </tspan>
      <tspan x="428.184" y="713.938">
        36&#10;
      </tspan>
      <tspan x="428.184" y="734.938">
        37
      </tspan>
    </text>
    <path
      d="M412 342C412 335.373 417.373 330 424 330H1128C1134.63 330 1140 335.373 1140 342V366H412V342Z"
      fill="white"
    />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="600"
      letterSpacing="0em"
    >
      <tspan x="751.457" y="352.9">
        Next.js
      </tspan>
    </text>
    <circle cx="434" cy="348" r="6" fill="#FD0054" />
    <circle cx="454" cy="348" r="6" fill="#FFB31A" />
    <circle cx="474" cy="348" r="6" fill="#00CC21" />
    <rect opacity="0.1" x="412" y="366" width="728" height="1" fill="#181A1B" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="536.449" y="398.938">
        {' '}
        (&#10;
      </tspan>
      <tspan x="486" y="419.938">
        {' '}
      </tspan>
      <tspan x="486" y="440.938">
        {' '}
      </tspan>
      <tspan x="570.082" y="440.938">
        {' '}
      </tspan>
      <tspan x="486" y="461.938">
        {'        '}
        {'{'}websites.
      </tspan>
      <tspan x="662.572" y="461.938">
        ((website){' '}
      </tspan>
      <tspan x="771.879" y="461.938">
        {' '}
        (&#10;
      </tspan>
      <tspan x="486" y="482.938">
        {' '}
      </tspan>
      <tspan x="603.715" y="482.938">
        {' '}
      </tspan>
      <tspan x="696.205" y="482.938">
        {'{'}
      </tspan>
      <tspan x="738.246" y="482.938">
        (
      </tspan>
      <tspan x="839.145" y="482.938">
        ){'}'}{' '}
      </tspan>
      <tspan x="898.002" y="482.938">
        {'{'}website.
      </tspan>
      <tspan x="990.492" y="482.938">
        {'}'}&#10;
      </tspan>
      <tspan x="486" y="503.938">
        {' '}
      </tspan>
      <tspan x="486" y="524.938">
        {' '}
      </tspan>
      <tspan x="679.389" y="524.938">
        {'{'}website.
      </tspan>
      <tspan x="889.594" y="524.938">
        .
      </tspan>
      <tspan x="931.635" y="524.938">
        [
      </tspan>
      <tspan x="948.451" y="524.938">
        ]{'}'}&#10;
      </tspan>
      <tspan x="486" y="545.938">
        {' '}
      </tspan>
      <tspan x="713.021" y="545.938">
        {'{'}website.
      </tspan>
      <tspan x="872.777" y="545.938">
        .
      </tspan>
      <tspan x="923.227" y="545.938">
        {'}'}&#10;
      </tspan>
      <tspan x="486" y="566.938">
        {' '}
      </tspan>
      <tspan x="704.613" y="566.938">
        {'{'}website.
      </tspan>
      <tspan x="864.369" y="566.938">
        .
      </tspan>
      <tspan x="906.41" y="566.938">
        {'}'}&#10;
      </tspan>
      <tspan x="486" y="587.938">
        {' '}
      </tspan>
      <tspan x="729.838" y="587.938">
        {'{'}website
      </tspan>
      <tspan x="889.594" y="587.938">
        .
      </tspan>
      <tspan x="956.859" y="587.938">
        {'}'}&#10;
      </tspan>
      <tspan x="486" y="608.938">
        {' '}
      </tspan>
      <tspan x="486" y="629.938">
        {' '}
      </tspan>
      <tspan x="486" y="650.938">
        {'        '}
        )){'}'}&#10;
      </tspan>
      <tspan x="486" y="671.938">
        {' '}
      </tspan>
      <tspan x="544.857" y="671.938">
        /
      </tspan>
      <tspan x="486" y="692.938">
        {' '}
      </tspan>
      <tspan x="528.041" y="692.938">
        /
      </tspan>
      <tspan x="486" y="713.938">
        {' '}
        );&#10;
      </tspan>
      <tspan x="486" y="734.938">
        {'}'};
      </tspan>
    </text>
    <text
      fill="#FD0054"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="486" y="398.938">
        return
      </tspan>
    </text>
    <text
      fill="#1A9900"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="528.041" y="419.938">
        LayoutMain
      </tspan>
      <tspan x="544.857" y="440.938">
        div
      </tspan>
      <tspan x="578.49" y="482.938">
        div
      </tspan>
      <tspan x="595.307" y="503.938">
        Page&#10;
      </tspan>
      <tspan x="586.898" y="629.938">
        div
      </tspan>
      <tspan x="553.266" y="671.938">
        div
      </tspan>
      <tspan x="536.449" y="692.938">
        LayoutMain
      </tspan>
    </text>
    <text
      fill="#8152E0"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="637.348" y="461.938">
        map
      </tspan>
      <tspan x="704.613" y="482.938">
        clsx
      </tspan>
    </text>
    <text
      fill="#001A9B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="519.633" y="419.938">
        &#60;
      </tspan>
      <tspan x="612.123" y="419.938">
        &#62;&#10;
      </tspan>
      <tspan x="536.449" y="440.938">
        &#60;
      </tspan>
      <tspan x="578.49" y="440.938">
        className=
      </tspan>
      <tspan x="1032.53" y="440.938">
        &#62;&#10;
      </tspan>
      <tspan x="755.062" y="461.938">
        =&#62;
      </tspan>
      <tspan x="570.082" y="482.938">
        &#60;
      </tspan>
      <tspan x="612.123" y="482.938">
        className=
      </tspan>
      <tspan x="746.654" y="482.938">
        &#39;flex-none&#39;
      </tspan>
      <tspan x="864.369" y="482.938">
        key=
      </tspan>
      <tspan x="973.676" y="482.938">
        id
      </tspan>
      <tspan x="586.898" y="503.938">
        &#60;
      </tspan>
      <tspan x="603.715" y="524.938">
        pageData=
      </tspan>
      <tspan x="755.062" y="524.938">
        attributes.pages
      </tspan>
      <tspan x="898.002" y="524.938">
        data
      </tspan>
      <tspan x="940.043" y="524.938">
        0
      </tspan>
      <tspan x="603.715" y="545.938">
        websiteTitle=
      </tspan>
      <tspan x="788.695" y="545.938">
        attributes
      </tspan>
      <tspan x="881.186" y="545.938">
        title
      </tspan>
      <tspan x="603.715" y="566.938">
        websiteSlug=
      </tspan>
      <tspan x="780.287" y="566.938">
        attributes
      </tspan>
      <tspan x="872.777" y="566.938">
        slug
      </tspan>
      <tspan x="603.715" y="587.938">
        websiteFavicon=
      </tspan>
      <tspan x="805.512" y="587.938">
        attributes
      </tspan>
      <tspan x="898.002" y="587.938">
        favicon
      </tspan>
      <tspan x="586.898" y="608.938">
        /&#62;&#10;
      </tspan>
      <tspan x="570.082" y="629.938">
        &#60;/
      </tspan>
      <tspan x="612.123" y="629.938">
        &#62;&#10;
      </tspan>
      <tspan x="536.449" y="671.938">
        &#60;
      </tspan>
      <tspan x="578.49" y="671.938">
        &#62;&#10;
      </tspan>
      <tspan x="519.633" y="692.938">
        &#60;
      </tspan>
      <tspan x="620.531" y="692.938">
        &#62;&#10;
      </tspan>
    </text>
    <text
      fill="#00CCCC"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="662.572" y="440.938">
        &#34;flex flex-nowrap py-28 px-8 gap-x-28 w-max&#34;
      </tspan>
    </text>
    <path
      d="M404 563H242V605"
      stroke="#AFB5B6"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="0.01 10"
    />
    <defs>
      <filter
        id="filter0_ddd_1112_11783"
        x="372"
        y="310"
        width="808"
        height="510"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1112_11783" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1112_11783"
          result="effect2_dropShadow_1112_11783"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1112_11783"
          result="effect3_dropShadow_1112_11783"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1112_11783"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1112_11783"
        x1="314"
        y1="613"
        x2="170"
        y2="757"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCFDFD" />
        <stop offset="1" stopColor="#F4F5F6" />
      </linearGradient>
    </defs>
  </svg>
);

NextjsInactive.propTypes = {
  className: PropTypes.string,
};

NextjsInactive.defaultProps = {
  className: null,
};

export default NextjsInactive;
